export const siteUrl = "https://www.coffeebooksandcake.com";

export const rssFeedUrl = `${siteUrl}/rss.xml`;
